// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"89ac1e53","453":"28bf9b2c","504":"323fb374","944":"024f3af2"}[chunkId] + ".chunk.js";
};